export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-480-eb2ea9549128efcd4a8d5409198464ef.webp";